// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"9ca00911","297":"2271557b","643":"822ee953","959":"6c974afa"}[chunkId] + ".chunk.js";
};